export default __webpack_public_path__ + "static/media/palette.2bb548a7.svg";